<script setup lang="ts">
import {first} from 'lodash';
import {useCartStore} from "../../stores/cart";
import CustomNumberInput from "../CustomNumberInput.vue";
import {onMounted, ref} from "vue";
import type {Ref} from "vue";
import {label} from "../../mixins/translations.js";
import {type ProductVariantResponse} from "../../../responses/ProductVariantResponse";
import {type ProductResponse} from "../../../responses/ProductResponse";

interface Props {
    product: ProductResponse
    showInput: boolean
}
const props = defineProps<Props>();
const selectedVariant: Ref<ProductVariantResponse|null> = ref(null);
const amount: Ref<Number> = ref(1);
const cart = useCartStore();
const selectVariant = (variant) => {
    selectedVariant.value = variant;
}
const addToCart = () => {
    cart.addItem({
        amount: amount.value,
        variant_id: selectedVariant.value?.id
    });

    // window.trackAddToCartGoogle(props.product, amount.value, 'add_to_cart');
    reset();
}
const reset = () => {
    handleAmountChange(1);
}
const handleAmountChange = (newAmount) => {
    amount.value = newAmount;
}
onMounted(() => {
    selectVariant(first(props.product.variants));
})
</script>
<template>
    <div class="gap-x-4 flex">
        <select v-model="selectedVariant" class="w-40 px-3 py-2 placeholder-gray-300 border border-secondary-300 rounded-md focus:outline-hidden focus:ring-3 focus:ring-primary-100 focus:border-primary-300">
            <option :value="variant" v-for="variant in props.product.variants" :selected="selectedVariant?.id === variant.id">{{ variant.name }}</option>
        </select>
        <custom-number-input v-if="showInput" :value="amount" @input="handleAmountChange"></custom-number-input>
        <div class="flex-initial">
            <button class="h-12 px-5 pointer rounded-xl flex items-center justify-center text-primary-foreground bg-primary hover:bg-primary-700 transition-all duration-500" @click="addToCart">
                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>
                <span class="ml-2 text-normal">{{ label('site.product.add_to_cart') }}</span>
            </button>
        </div>
    </div>
</template>
